import { gql } from '@apollo/client';

export const CREATE_ACCESS_GROUP = gql`
  mutation CreateAccessGroup($name: String!) {
    createAccessGroup(input: { name: $name }) {
      name
    }
  }
`;

export const DELETE_ACCESS_GROUP = gql`
  mutation deleteAccessGroup($accessGroupId: String!) {
    deleteAccessGroup(input: { accessGroupId: $accessGroupId })
  }
`;

export const ADD_TO_ACCESS_GROUP = gql`
  mutation InviteToAccessGroup($accessGroup: String!, $invitees: [String!]) {
    InviteToAccessGroup(invitees: $invitees, accessGroup: $accessGroup) {
      id
      name
      description
      members {
        id
        firstName
        lastName
        email
      }
      jobs {
        job {
          id
          title
        }
      }
    }
  }
`;

export const REMOVE_USER_FROM_ACCESS_GROUP = gql`
  mutation removeUserAccessGroup($accessGroupId: String!, $userId: String!) {
    removeUserAccessGroup(input: { accessGroupId: $accessGroupId, userId: $userId }) {
      id
      firstName
      lastName
      email
    }
  }
`;

export const CLIENT_MEMBERS = gql`
  query ClientMembers {
    viewer {
      client {
        members {
          totalCount
          nodes {
            id
            firstName
            lastName
            email
            flag
            isAdmin
            client {
              id
            }
          }
        }
      }
    }
  }
`;

export const REMOVE_FROM_ORG = gql`
  mutation removeUserFromOrganization($userId: String!) {
    RemoveUserFromOrganization(input: { userId: $userId }) {
      __typename
      ... on User {
        id
        firstName
        lastName
      }

      ... on NotFound {
        message
      }
    }
  }
`;

export const EDIT_USER_INFO = gql`
  mutation editUserInfo(
    $firstName: String
    $lastName: String
    $email: String
    $phone: String
    $emailProductUpdates: Boolean
  ) {
    editUserInfo(
      input: {
        firstName: $firstName
        lastName: $lastName
        email: $email
        phone: $phone
        emailProductUpdates: $emailProductUpdates
      }
    ) {
      id
      firstName
      lastName
      email
      phone
      settings {
        emailProductUpdates
      }
    }
  }
`;

export const ACCOUNT_INFORMATION = gql`
  query UserClient {
    viewer {
      client {
        orgName
        contact {
          firstName
          lastName
          email
          phone
        }
        contract {
          startDate
          endDate
          signer {
            email
            firstName
            lastName
            phone
          }
          quotas {
            adminQuota
            userQuota
            interviewQuota
            usedInterviews
            adminCount
            userCount
          }
        }
      }
    }
  }
`;

export const CONTRACT = gql`
  query UserClient {
    viewer {
      client {
        contract {
          startDate
        }
      }
    }
  }
`;
